<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card mb-3" v-if="zangyou.time > 0">
                    <div class="card-header p-1 text-center">
                        時間外勤務
                    </div>
                    <div class="card-body">
                        <div v-show="zangyou_loading" class="mb-2 mt-n2">
                            <b-spinner small /> loading...
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="w-100 h-100 mb-1">
                                    <div class="form-group mb-3">
                                        <button
                                            @click="approve('admin')"
                                            :style="{cursor:button_admin.disabled ? 'default' : '' }"
                                            :disabled="button_admin.disabled"
                                            :class="'btn btn-'+button_admin.btn_color+ ' btn-sm'"
                                        >管理者承認： {{ button_admin.status }}</button>
                                    </div>
                                    <div class="form-group mb-3">
                                        <button
                                            @click="approve('shachou')"
                                            :style="{cursor:button_shachou.disabled ? 'default' : '' }"
                                            :disabled="button_shachou.disabled"
                                            :class="'btn btn-' + button_shachou.btn_color + ' btn-sm'"
                                        >社長承認： {{ button_shachou.status }}</button>
                                    </div>
                                    <div class="form-group mb-3">
                                        <a :href="'/application/'+ zangyou.id"
                                            class="btn btn-success btn-sm"
                                            target="_blank"
                                        >申請詳細</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="input-group input-group-sm mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">開始時間</span>
                                    </div>
                                    <b-form-input
                                        v-model="zangyou.schedule_start"
                                        disabled
                                        class="text-right bg-white"
                                        type="text"
                                    ></b-form-input>
                                </div>
                                <div class="input-group input-group-sm mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">終了時間</span>
                                    </div>
                                    <b-form-input
                                        v-model="zangyou.schedule_end"
                                        disabled
                                        class="text-right bg-white"
                                        type="text"
                                    ></b-form-input>
                                </div>
                                <div class="input-group input-group-sm mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">勤務時間</span>
                                    </div>
                                    <b-form-input
                                    v-model="zangyou.time"
                                    disabled
                                    class="text-right bg-white"
                                    type="text"
                                    step="0.01"
                                    min="0"
                                    ></b-form-input>
                                </div>
                            </div>
                        </div>
                        <p class="text-muted">業務内容 : {{zangyou.note.work_contents}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
export default {
    props: ["userName", "day", "zangyou_was_applied", "approver_id"],
    data: function() {
        return {
            moment: moment,
            text: "",
            zangyou_loading: true,
            zangyou: { time: 0, schedule_start: "", schedule_end: "", appr: [], note:{work_contents:null} }
        }
    },
    props: ["userName", "day", "zangyou_was_applied", "approver_id"],
    computed:{
        button_admin: function(){
            return {
                disabled: this.zangyou.appr.admin || this.approver_id != authUser.id,
                status: this.zangyou.appr.admin ? '済' : this.approver_id == authUser.id ? 'する' : '待ち',
                btn_color: this.zangyou.appr.admin ? 'success' : this.approver_id == authUser.id ? 'primary' : 'secondary',
            }
        },
        button_shachou: function(){
            return {
                disabled: this.zangyou.appr.shachou || !this.$can('社長承認') || !this.zangyou.appr.admin,
                status: this.zangyou.appr.shachou ? '済' : this.$can('社長承認') ? 'する' : '待ち',
                btn_color: this.zangyou.appr.shachou ? 'success' : this.$can('社長承認') ? 'primary' : 'secondary',
            }
        }
    },
    methods: {
        getZangyou() {
            window.axios
            .get("/api/user/" + this.userName + "/date/" + this.day + "/getZangyou")
            .then(response => {
                var data = response.data;
                if (response.status == 200) {
                    this.zangyou = data.zangyou;
                    this.zangyou.schedule_start = moment(
                        this.zangyou.schedule_start
                    ).format("HH:mm");
                    this.zangyou.schedule_end = moment(
                        this.zangyou.schedule_end
                    ).format("HH:mm");
                } else {
                }
            })
            .catch(error => {})
            .finally(() => {
                this.zangyou_loading = false;
                this.$emit("zangyouUpdated", this.zangyou);
            });
        },
        approve(approver) {
            this.zangyou_loading = true;

            window.axios.post('/api/application/'+this.zangyou.id+'/approve', {
                auth_user: authUser,
                action: approver
            }).then( response => {
                this.getZangyou()
            }).finally(()=>{
                this.zangyou_loading = false;
            })
        }
    },
    watch: {
        userName() {
            if (this.userName != "") {
            this.getZangyou();
            }
        },
        zangyou_was_applied() {
            this.getZangyou();
        }
    },
    mounted() {
        this.getZangyou();
    }
}
</script>
